module.exports = __webpack_public_path__ + "static/img/home_foto5.98e9cfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home_foto5.png
// module id = 17
// module chunks = 0